import React from "react"; 
import { Link } from "react-router-dom";    
import EditRegionForm from "../../../components/Dashboard/RegionsListContent/Edit";

const EditRegion = () => {
  return (
    <>
      {/* Breadcrumb */}
      {/* <div className="breadcrumb-card">
        <h5>Edit Region</h5>

        <ul className="breadcrumb">
          <li>
            <Link to="/dashboard/ecommerce/">
              <i className="material-symbols-outlined">home</i>
              Dashboard
            </Link>
          </li>
          <li>eCommerce</li>
          <li>Edit Region</li>
        </ul>
      </div> */}

      <EditRegionForm />
    </>
  );
};

export default EditRegion;
